import { Navigate } from 'react-router-dom';
import { APP_PREFIX_PATH } from '../../constant/constant';


function LogoutComponent() {
  localStorage.removeItem('token1');
  localStorage.removeItem('admin_id');
  localStorage.removeItem('admin_name');
  localStorage.removeItem('admin_email');
  localStorage.removeItem('admin_mobile');

  localStorage.removeItem('user_type');
  return (
    <>
      <Navigate to={`${APP_PREFIX_PATH}/`} />
    </>
  );
}

export default LogoutComponent;
